import React from "react";

import Accordion from "../accordion";
import ImageGallery from "./image-gallery";
import NoShots from "./components/no-shots";

import { DEFAULT_LOCALE, sortByLocale } from "../photography/lib/helpers";

const LocaleGallery = ({ label, photographyWipKey, shots, version }) => {
    const productShotsByLocale = sortByLocale(shots);
    const localeAccordions = Object.keys(productShotsByLocale).map((key) => {
        const productShots = productShotsByLocale[key];

        if (productShots.length <= 0) {
            return <NoShots key={key} label={DEFAULT_LOCALE.text} />;
        }

        const locale = productShots[0].locale || DEFAULT_LOCALE.text;

        return <ImageGallery key={key} wipKey={photographyWipKey} label={locale} shots={productShots} version={version} />;
    });

    return (
        <div label={label}>
            <Accordion openAll={true} loadOnOpen={false}>
                {localeAccordions}
            </Accordion>
        </div>
    );
};

LocaleGallery.defaultProps = {
    shots: [],
};

export default LocaleGallery;
